import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { api, formatError, jobId } from "@/lib/api";

const EMPTY = { title: "", department: "", location: "Brownsville, TX (Port of Brownsville)", employment_type: "FULL_TIME", status: "open", summary: "", responsibilities: "", requirements: "", salary_note: "", owner: "", valid_through: "" };
const field = "rounded-none border-white/15 bg-[#061235]";

export const JobDialog = ({ job, onClose, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  useEffect(() => {
    if (job) setF({ ...EMPTY, ...job, responsibilities: (job.responsibilities ?? []).join("\n"), requirements: (job.requirements ?? []).join("\n"), valid_through: job.valid_through ?? "" });
  }, [job]);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const save = async (e) => {
    e.preventDefault();
    const lines = (s) => s.split("\n").map((x) => x.trim()).filter(Boolean);
    const body = { title: f.title, department: f.department, location: f.location, employment_type: f.employment_type, status: f.status, summary: f.summary, salary_note: f.salary_note || "[Compensation range — add before publishing]", owner: f.owner || "[Hiring owner]", valid_through: f.valid_through || null, responsibilities: lines(f.responsibilities), requirements: lines(f.requirements) };
    try {
      if (jobId(job)) await api.put(`/admin/jobs/${jobId(job)}`, body);
      else await api.post("/admin/jobs", body);
      toast.success("Role saved");
      onSaved();
      onClose();
    } catch (err) {
      toast.error(formatError(err));
    }
  };
  const inp = (k, label, props = {}) => <div><Label htmlFor={`j-${k}`}>{label}</Label><Input id={`j-${k}`} value={f[k]} onChange={set(k)} data-testid={`job-form-${k}`} className={field} {...props} /></div>;
  return (
    <Dialog open={!!job} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="job-dialog" className="max-h-[90vh] overflow-y-auto rounded-none border-white/15 bg-[#0B1D4F] sm:max-w-2xl" data-lenis-prevent>
        <DialogHeader><DialogTitle className="font-display text-3xl font-black uppercase">{jobId(job) ? "Edit role" : "New role"}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="grid gap-4 md:grid-cols-2">
          {inp("title", "Title", { required: true })}
          {inp("department", "Department", { required: true })}
          {inp("location", "Location")}
          {inp("owner", "Posting owner")}
          {inp("salary_note", "Compensation")}
          {inp("valid_through", "Valid through", { type: "date" })}
          <div className="md:col-span-2"><Label htmlFor="j-summary">Summary</Label><Textarea id="j-summary" required rows={3} value={f.summary} onChange={set("summary")} data-testid="job-form-summary" className={field} /></div>
          <div><Label htmlFor="j-resp">Responsibilities (one per line)</Label><Textarea id="j-resp" rows={4} value={f.responsibilities} onChange={set("responsibilities")} data-testid="job-form-responsibilities" className={field} /></div>
          <div><Label htmlFor="j-req">Requirements (one per line)</Label><Textarea id="j-req" rows={4} value={f.requirements} onChange={set("requirements")} data-testid="job-form-requirements" className={field} /></div>
          <button type="submit" data-testid="job-form-save" className="bg-[#C8102E] py-3 font-semibold text-white md:col-span-2">Save role</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
